/* istanbul ignore file */
export enum LicenseTiers {
    PerSite = 0,
    Tier1 = 1,
    //enum 2/Silver was removed for 2026 pricing update
    Tier2 = 3,
    Tier3 = 4,
    Tier4 = 5,
    Tier5 = 6,
    Other = 7,
}

export enum LicenseTiersName {
    PerSite = "Per Site",
    Tier1 = "Tier 1",
    Tier2 = "Tier 2",
    Tier3 = "Tier 3",
    Tier4 = "Tier 4",
    Tier5 = "Tier 5",
    Other = "Other",
}
